var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThirdParty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: 24,
      height: 24,
      verticalAlign: "middle",
      fill: "#ffffff",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M698.8 646.4c-25.8 8.5-53.5-5.6-62-31.3-8.5-25.8 5.6-53.5 31.3-62 25.8-8.5 53.5 5.6 62 31.3 8.5 25.8-5.5 53.6-31.3 62zM557.1 391.8c-19.2 19.2-50.3 19.2-69.4 0-19.2-19.2-19.2-50.3 0-69.4 19.2-19.2 50.3-19.2 69.4 0 19.2 19.2 19.2 50.3 0 69.4zM430.5 639.2c-5.5 26.6-31.4 43.7-58 38.2s-43.7-31.4-38.2-58 31.4-43.7 58-38.2c26.5 5.4 43.6 31.4 38.2 58zM346.4 554.1c-0.8-7.1-1.3-14.3-1.3-21.5 0-34.1 9.6-67.3 27.7-96 17.6-27.9 42.6-50.4 72.1-65.1l30.2 60.7c-38.4 19.1-62.2 57.6-62.2 100.5 0 4.5 0.3 9 0.8 13.4l-67.3 8zM525 712.5c-32.8 0-65-8.9-93-25.9l35.1-58c17.4 10.5 37.4 16.1 57.9 16.1 25.1 0 48.9-8.1 68.7-23.5l41.5 53.5c-31.8 24.8-69.9 37.8-110.2 37.8zM636.8 523.1c-3.4-40.4-28.5-75.9-65.4-92.7l28-61.7c59.3 26.9 99.5 83.9 105 148.7l-67.6 5.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M787.1 840.6h-532c-32.5 0-59-26.5-59-59v-532c0-32.5 26.5-59 59-59H787c32.5 0 59 26.5 59 59v531.9c0.1 32.6-26.4 59.1-58.9 59.1z m-522.9-68.1H778V258.7H264.2v513.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdParty);
export default __webpack_public_path__ + "static/media/third-party.23761a9452ee1cace0baec7e5ae75348.svg";
export { ForwardRef as ReactComponent };